import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace ExpenseType {
    /**
    * 列表
    */
    export var GetList = (query: any): Promise<any> => {
        return Get(`/msls/ExpenseType/GetList?${qs.stringify(query)}`, {});
    };
    /**
    * 新增
    */
    export var AddOrEdit = (body: any): Promise<any> => {
        return Post(`/msls/ExpenseType/AddOrEdit`, body);
    };
    /**
    * 详情
    */
    export var GetDetail = (id): Promise<any> => {
        return Get(`/msls/ExpenseType/GetDetail/${id}`, {});
    };
    /**
     * 删除
     */
    export var DoDelete = (id: any): Promise<any> => {
        return Put(`/msls/ExpenseType/Delete/${id}`, {});
    };


}
